// ShowMessagesForModeration.jsx
import React, { useState, useEffect } from 'react';
import { messagesApi } from './messagesApi';
import TableMessagesForModeration from './TableMessagesForModeration';

const optionsStatuses = [
    { value: 'all', text: 'Всі' },
    { value: 'new', text: 'Нові' },
    { value: 'info', text: 'В роботі' },
    { value: 'closed', text: 'Закриті' },
];

const ShowMessagesForModeration = () => {
    const [formData, setFormData] = useState({
        email: '',
        dateFrom: new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        dateTo: new Date().toISOString().split('T')[0],
        status: 'new'
    });
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const getMessages = async () => {
        const { email, dateFrom, dateTo, status } = formData;

        if (email && email !== 'all' && !email.match(/[a-z,\d]{1,30}[@]{1}[a-z,\d,.]{1,30}/)) {
            alert('Невірний формат пошти');
            return;
        }

        setLoading(true);

        try {
            const response = await messagesApi.getMessagesList(
                email || 'all',
                new Date(dateFrom).toISOString(),
                new Date(dateTo).toISOString(),
                status
            );
            
            if (response.data) {
                setMessages(response.data);
                setShowTable(true);
            }
        } catch (error) {
            console.error('Error fetching messages:', error);
            alert('Виникла помилка при отриманні даних');
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = () => {
        getMessages();
    };

    return (
        <div>
            {/* Filters */}
            <div className="container-fluid">
                <div className="container">
                    <div className="card">
                        <div className="card-header bg-light">
                            <h5 className="card-title mb-0">Фільтри пошуку</h5>
                        </div>
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-md-3">
                                    <label htmlFor="email" className="form-label">Електронна пошта</label>
                                    <input
                                        type="text"
                                        id="email"
                                        className="form-control"
                                        value={formData.email}
                                        onChange={(e) => handleInputChange('email', e.target.value)}
                                        placeholder="Введіть email"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="dateFrom" className="form-label">Дата від</label>
                                    <input
                                        type="date"
                                        id="dateFrom"
                                        className="form-control"
                                        value={formData.dateFrom}
                                        onChange={(e) => handleInputChange('dateFrom', e.target.value)}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="dateTo" className="form-label">Дата по</label>
                                    <input
                                        type="date"
                                        id="dateTo"
                                        className="form-control"
                                        value={formData.dateTo}
                                        onChange={(e) => handleInputChange('dateTo', e.target.value)}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label htmlFor="status" className="form-label">Статус</label>
                                    <select
                                        id="status"
                                        className="form-select"
                                        value={formData.status}
                                        onChange={(e) => handleInputChange('status', e.target.value)}
                                    >
                                        {optionsStatuses.map(el => (
                                            <option key={el.value} value={el.value}>{el.text}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2 d-flex align-items-end">
                                    <button
                                        className="btn btn-primary w-100"
                                        onClick={getMessages}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                Завантаження...
                                            </>
                                        ) : (
                                            'Пошук'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Results Table */}
                    {showTable && (
                        <div className="mt-4">
                            <TableMessagesForModeration 
                                messages={messages} 
                                onUpdate={handleUpdate} 
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ShowMessagesForModeration;